export function infiniteScroll() {
    const portfolioList = document.querySelector('.p-project-portfolio__list');
    const filterButtons = document.querySelectorAll('.c-portfolio__filter-btn');
    
    if (!portfolioList) return;

    let currentPage = 1;
    let isLoading = false;
    let hasMore = true;

    // 現在のフィルター状態を取得
    function getCurrentFilter() {
        const activeButton = document.querySelector('.c-portfolio__filter-btn.is-active');
        if (!activeButton) {
            return { taxonomy: '', term_id: 0, category: '' };
        }
        
        const filterCategory = activeButton.getAttribute('data-category');
        
        if (filterCategory === 'all') {
            return { taxonomy: '', term_id: 0, category: '' };
        }
        
        // カテゴリスラッグが指定されている場合
        return { 
            taxonomy: 'portfolio-cat', 
            term_id: 0, 
            category: filterCategory 
        };
    }

    // ローディング表示を作成
    function createLoadingElement() {
        const loading = document.createElement('div');
        loading.className = 'p-project-portfolio__loading';
        loading.innerHTML = `
            <div class="p-project-portfolio__loading-spinner"></div>
            <p class="p-project-portfolio__loading-text">読み込み中...</p>
        `;
        return loading;
    }

    // エラー表示を作成
    function createErrorElement() {
        const error = document.createElement('div');
        error.className = 'p-project-portfolio__error';
        error.innerHTML = `
            <p class="p-project-portfolio__error-text">エラーが発生しました。再試行してください。</p>
            <button class="p-project-portfolio__retry-btn c-btn">再試行</button>
        `;
        return error;
    }

    // Ajax でポストを読み込み
    function loadMorePosts() {
        if (isLoading || !hasMore) return;

        isLoading = true;
        
        // ローディング中のクラスを追加
        portfolioList.classList.add('is-loading');
        
        // ローディング表示を追加
        const loadingElement = createLoadingElement();
        portfolioList.appendChild(loadingElement);

        const filter = getCurrentFilter();
        
        const data = {
            action: 'portfolio_infinite_scroll',
            page: currentPage + 1,
            nonce: ajax_object.nonce,
            taxonomy: filter.taxonomy,
            term_id: filter.term_id,
            category: filter.category,
            current_url: window.location.href
        };

        fetch(ajax_object.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(data)
        })
        .then(response => response.json())
        .then(data => {
            // ローディング表示を削除
            loadingElement.remove();
            
            // ローディング中のクラスを削除
            portfolioList.classList.remove('is-loading');
            
            if (data.posts) {
                // 新しいポストを追加
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data.posts;
                
                while (tempDiv.firstChild) {
                    portfolioList.appendChild(tempDiv.firstChild);
                }

                currentPage = data.current_page;
                hasMore = data.has_more;
                
                // アニメーション効果（オプション）
                const newCards = portfolioList.querySelectorAll('.p-project-portfolio__card:not(.loaded)');
                newCards.forEach((card, index) => {
                    card.classList.add('loaded');
                    card.style.opacity = '0';
                    card.style.transform = 'translateY(20px)';

                    setTimeout(() => {
                        card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                        card.style.opacity = '1';
                        card.style.transform = 'translateY(0)';
                    }, index * 100);
                });
            }
            
            if (!hasMore) {
                // 全ての投稿を読み込み完了
                portfolioList.classList.add('is-completed');
                const endMessage = document.createElement('div');
                endMessage.className = 'p-project-portfolio__end-message';
                endMessage.innerHTML = '<p>全ての投稿を表示しました</p>';
                portfolioList.appendChild(endMessage);
            }
            
            isLoading = false;
        })
        .catch(() => {
            // ローディング表示を削除
            loadingElement.remove();
            
            // ローディング中のクラスを削除
            portfolioList.classList.remove('is-loading');
            
            // エラー表示を追加
            const errorElement = createErrorElement();
            portfolioList.appendChild(errorElement);
            
            // 再試行ボタンのイベントリスナー
            const retryBtn = errorElement.querySelector('.p-project-portfolio__retry-btn');
            retryBtn.addEventListener('click', () => {
                errorElement.remove();
                loadMorePosts();
            });
            
            isLoading = false;
        });
    }

    // スクロール監視
    function handleScroll() {
        if (isLoading || !hasMore) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.offsetHeight;
        
        // グラデーション領域（240px）に到達したら読み込み開始
        const isMobile = window.innerWidth <= 768;
        const triggerDistance = isMobile ? 1100 : 1100;
        
        if (scrollTop + windowHeight >= documentHeight - triggerDistance) {
            loadMorePosts();
        }
    }

    // フィルターが変更されたときの処理
    function resetInfiniteScroll() {
        currentPage = 1;
        hasMore = true;
        isLoading = false;
        
        // グラデーション関連のクラスをリセット
        portfolioList.classList.remove('is-loading', 'is-completed');
        
        // ローディング、エラー、終了メッセージを削除
        const existingMessages = portfolioList.querySelectorAll(
            '.p-project-portfolio__loading, .p-project-portfolio__error, .p-project-portfolio__end-message'
        );
        existingMessages.forEach(el => el.remove());
    }


    // フィルターボタンにイベントリスナーを追加
    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            // 少し遅らせてページが更新された後にリセット
            setTimeout(() => {
                resetInfiniteScroll();
            }, 100);
        });
    });

    // スクロールイベントにスロットリングを適用
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    }

    // イベントリスナーを登録
    window.addEventListener('scroll', onScroll);
    
    // 初期化時に既存のカードにloadedクラスを追加
    const existingCards = portfolioList.querySelectorAll('.p-project-portfolio__card');
    existingCards.forEach(card => {
        card.classList.add('loaded');
    });

    // ページネーションが存在する場合は非表示にする
    const pagination = document.querySelector('.pagination, .page-numbers');
    if (pagination) {
        pagination.style.display = 'none';
    }

    // 初期状態ではインフィニットスクロールは通常動作
}
